import { forwardRef, InputHTMLAttributes } from "react";
import { FieldError } from "react-hook-form";
import InputError from "../InputError";
import { InputLabel } from "@earned/core";

type TextAreaProps = InputHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  error?: FieldError;
  rows?: number;
};

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ required, placeholder, error, label, ...rest }, ref) => {
    return (
      <div className={`relative flex flex-col`}>
        {label && <InputLabel label={label} required={required} />}
        <textarea
          ref={ref}
          className={
            `rounded border border-green-100 px-4 py-4 text-purple-2-900 placeholder:text-purple-2-300 placeholder:text-purple-2-500 focus:outline-purple-2-100 focus:outline-purple-2-700 focus:ring-purple-2-700 ` +
            (error
              ? "border-red-900 text-red-900 placeholder:text-red-900 focus:outline-red-900"
              : "")
          }
          placeholder={placeholder}
          {...rest}
        />
        {error && <InputError value={error.message} />}
      </div>
    );
  }
);

TextArea.displayName = "TextArea";

export default TextArea;
